/*
 * Filename: d:\projects\AutoFiFront\src\Content\Car\CarEquipment\CarEquipment.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, February 3rd 2023, 10:19:08 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import React, { useState } from "react";
import styles from "Content/Car/CarEquipment/CarEquipment.module.css";
import translator from "MultiLanguage/TranslationWrapper";
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";
import CollapseEquipment from "Content/CollapseBox/CollapseEquipment/CollapseEquipment";

type equipmentType = {
    Equipment: {id: number, Name: string, Optionnal: boolean}[],
    themeColor: string
};

function CarEquipment(props: equipmentType) {
    const optionnalEquipment = props.Equipment.filter(element => {
        return element.Optionnal == true;
    });
    const serialEquipment = props.Equipment.filter(element => {
        return element.Optionnal == false;
    });
    const [displayBlurSerial, setDisplayBlurSerial] = useState(true);
    const [displayBlurOptional, setDisplayBlurOptional] = useState(true);
    const themeColor = props.themeColor== "CITYCAR" ? "var(--root-colors-second)" : props.themeColor == "SUV" ? "var(--root-colors-third)" : props.themeColor == "UTILITY" ? "var(--root-colors-fourth)" : props.themeColor == "SEDAN" ? "var(--root-colors-fifth)" : props.themeColor == "BREAK" ? "var(--root-colors-sixth)" : "var(--root-colors-first)";

    return (
        <React.Fragment>
                {serialEquipment.length > 0 ?
                    <div className={`${styles.equipementHolder}`}>
                        <button className={`${styles.buttonEquipment}`} onClick={ ()=> setDisplayBlurSerial(!displayBlurSerial)}>
                            <div className={`${styles.titleEquipment}`}>
                                <h3>{translator.decode("equipement.standard")} {serialEquipment.length}</h3>
                                {
                                    displayBlurSerial ? <IoIosArrowDropdownCircle fill={themeColor}/> : <IoIosArrowDropupCircle fill={themeColor}/>
                                }
                            </div>
                        </button>
                        {
                            displayBlurSerial ?
                                <CollapseEquipment status={displayBlurSerial} itemList={serialEquipment} nbItem={4} isBlury={true}/>
                                : null
                        }
                        {
                            !displayBlurSerial ?
                                <CollapseEquipment status={!displayBlurSerial} itemList={serialEquipment} nbItem={999} isBlury={false}/>
                                :null
                        }
                    </div>
                : null}
                {optionnalEquipment.length > 0 ?
                    <div className={`${styles.equipementHolder}`}>
                        <button className={`${styles.buttonEquipment}`} onClick={ ()=> setDisplayBlurOptional(!displayBlurOptional)}>
                            <div className={`${styles.titleEquipment}`}>
                                <h3>{translator.decode("equipement.optional")} {optionnalEquipment.length}</h3>
                                {
                                    displayBlurOptional ? <IoIosArrowDropdownCircle fill={themeColor}/> : <IoIosArrowDropupCircle fill={themeColor}/>
                                }
                            </div>
                        </button>
                        {
                            displayBlurOptional ?
                                <CollapseEquipment status={displayBlurOptional} itemList={optionnalEquipment} nbItem={4} isBlury={true}/>
                                : null
                        }
                        {
                            !displayBlurOptional ?
                                <CollapseEquipment status={!displayBlurOptional} itemList={optionnalEquipment} nbItem={999} isBlury={false}/>
                                :null
                        }
                    </div>
                : null}
        </React.Fragment>
    );
}

export default CarEquipment;
